.tabs {
  display: flex;
  gap: 4px;
  padding: 8px 16px 0;
}

.tab {
  flex: 1;
  padding: 8px 10px;
  background: transparent;
  border: 1px solid var(--kh-border);
  border-radius: 6px;
  font: inherit;
  color: var(--kh-text-secondary);
  cursor: pointer;
}

.tab:hover {
  background: var(--kh-off-white);
  color: var(--kh-text-primary);
}

.tabActive {
  background: var(--kh-red-dim);
  color: var(--kh-red);
  border-color: var(--kh-red);
  font-weight: 600;
}
